var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1D8F8C96-7DD9-49CB-B998-B1EA3CDF6161") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Settings-Integrations",
    transform: "translate(-164.000000, -1850.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GooglePlayStore",
    transform: "translate(164.000000, 1850.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "PlayStore",
    mask: "url(#mask-2)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.000000, 1.000000)",
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.1989118,31.4514233 C38.9061636,28.3176302 43.2329876,25.9297131 43.6059257,25.7441718 C44.7989565,25.1096203 46.030951,23.4304712 43.6059257,22.1261156 C42.8229413,21.7160693 38.6074419,19.4023687 33.1989118,16.418864 L25.7011864,23.9908062 L33.1989118,31.4514233 Z",
    fill: "#FFD900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7011864,23.9908062 L1.8275822,48.0518071 C2.38791705,48.1260237 3.02061302,47.9775906 3.7664892,47.5675441 C5.33245811,46.7103432 21.9328418,37.6447933 33.1989118,31.4532789 L25.7011864,23.9908062 Z",
    fill: "#F43249"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7011864,23.9908062 L33.1989118,16.4559723 C33.1989118,16.4559723 5.44563832,1.31023274 3.7664892,0.41592348 C3.13379323,0.0411299733 2.42502532,-0.0701948306 1.79047393,0.0411299733 L25.7011864,23.9908062 Z",
    fill: "#00EE76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7011864,23.9908062 L1.79047393,0.0411299733 C0.820092722,0.265634994 0,1.12283598 0,2.87620165 C0,5.67416505 0,42.9030349 0,45.2167355 C0,46.821668 0.634551381,47.9775906 1.8275822,48.0889154 L25.7011864,23.9908062 Z",
    fill: "#00D3FF"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStore);
export default __webpack_public_path__ + "static/media/PlayStore.a442e4bf9ab8ef2881e2aa9338662282.svg";
export { ForwardRef as ReactComponent };